export default __webpack_public_path__ + "static/media/ht.c1bb84e0.svg";